query Parameters {
    parameters {
        id
        name(language: "en") {
            language
            text
        }
        dataType
        deprecated
        units
    }
}
